export const DEFAULT_FREQUENCIES = 99;
export const DEFAULT_TYPES = [
  {
    text_key: 'interval_type_1',
    value: 'Day',
    id: 1,
  },
  {
    text_key: 'interval_type_2',
    value: 'Week',
    id: 2,
  },
  {
    text_key: 'interval_type_3',
    value: 'Month',
    id: 3,
  },
  {
    text_key: 'interval_type_5',
    value: 'Year',
    id: 5,
  },
];



// WEBPACK FOOTER //
// ./src/constants/DefaultIntervals.js